var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotAligned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Aligned",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Not_Aligned",
    "data-name": "Not Aligned",
    transform: "translate(3873.166 2010)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13018",
    "data-name": "Path 13018",
    d: "M46.834,8a8,8,0,1,1-8-8,8,8,0,0,1,8,8",
    transform: "translate(-3904 -2010)",
    fill: "#ff6961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13019",
    "data-name": "Path 13019",
    d: "M42.491,5.562,41.272,4.343,38.834,6.781,36.4,4.343,35.177,5.562,37.615,8l-2.438,2.438L36.4,11.657l2.438-2.438,2.438,2.438,1.219-1.219L40.053,8Z",
    transform: "translate(-3904 -2010)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAligned);
export default __webpack_public_path__ + "static/media/Not-Aligned.a5c798e337248e8e46d9b55631242bef.svg";
export { ForwardRef as ReactComponent };